module.exports = __webpack_public_path__ + "static/media/politicas_y_proteccion_de_datos_notaria_10.e5c2fe89.pdf";